import type { ObservationDeleteSidePanelProps } from "./observation-delete-side-panel.type";

import { useObservationDelete } from "@/entities/observation";
import { useSidePanel } from "@/modules/side-panel";

export const useObservationDeleteSidePanel = ({
  observation,
  options,
}: ObservationDeleteSidePanelProps) => {
  const { closeSidePanel } = useSidePanel();
  const { deleteObservation, isPending } = useObservationDelete(
    observation.id,
    options
  );

  return {
    isPending,
    onCancelClick: () => closeSidePanel(),
    onDeleteClick: () => deleteObservation(),
  };
};
